// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 265 ? "component---node-modules-smooth-doc-src-templates-doc-js" : chunkId) + "-" + {"265":"1b70377236d2f6de7d1c","897":"42dbce115de68f9cb3fb"}[chunkId] + ".js";
};